import {handleLoadMore} from "./peopleFilter";

const publicationsPages=document.querySelectorAll('.people-filter-page');

for (const publicationsPageWrapper of publicationsPages) {
    // init load more button for paginated-list
    const paginatedListWrapper=publicationsPageWrapper.querySelector('.paginated-list');

    if(paginatedListWrapper){
        handleLoadMore(paginatedListWrapper);
    }


    const paginatedFilterListWrapper=publicationsPageWrapper.querySelector('.paginated-filter-list');

    if(!paginatedFilterListWrapper) continue;

    const filters=paginatedFilterListWrapper.querySelectorAll('[data-filterprop]');
    if(!filters || !filters.length) continue;

    const items = paginatedFilterListWrapper.querySelectorAll('.filter-list-item');
    if (!items || !items.length) continue;

    /**
     * @type {NodeListOf<Element>}
     */
    const hiddenSeminarList=publicationsPageWrapper.querySelectorAll('.hidden-seminar-list>.people-seminar-card');

    /**
     * @type {Node}
     */
    let insertedSeminarCard=null;

    let initialFilterUsed=false;

    const firstPageCount=12;

    for(const filter of filters){
        filter.addEventListener('change', e=>{
            const filterTarget=filter.dataset.filterprop;
            if(!filterTarget) return;

            const filterValue=e.target.value;

            // when any filter is used for the first time
            if(!initialFilterUsed && filterValue && filterValue!=""){
                initialFilterUsed=true;
                // remove all elements with the class 'hide-on-filter' from the DOM
                const itemsToRemove=publicationsPageWrapper.querySelectorAll('.hide-on-filter');
                for(const item of itemsToRemove){
                    item.remove();
                }
            }

            for(const otherFilter of filters){ // reset all other filters when a filter is selected
                if(otherFilter!==filter){
                    otherFilter.value="";
                }
            }

            const visibleItemsMap={}; // track already displayed items to not display doubles
            const visibleItemsList=[];

            for(const item of items){
                const itemPropValue=item.dataset[filterTarget];
                const itemUid=item.dataset.uid;

                if(!visibleItemsMap[itemUid] && (!itemPropValue || !filterValue || filterValue=="" || itemPropValue==filterValue)){
                    item.classList.remove('hidden-by-filter');
                    visibleItemsList.push(item);

                    if(itemUid){
                        visibleItemsMap[itemUid]=true;
                    }
                    // initially only display 12 items after filtering
                    if(visibleItemsList.length>firstPageCount){
                        item.classList.add('hidden-by-pagination')
                    }else{
                        item.classList.remove('hidden-by-pagination')
                    }
                }else{
                    item.classList.add('hidden-by-filter');
                    item.classList.add('hidden-by-pagination')
                }

            }


            handleLoadMore(paginatedFilterListWrapper);

            // special behavior for seminar filter
            if(insertedSeminarCard){ // when any filter is set remove the special seminar card from list
                insertedSeminarCard.remove();
            }

            if(filterTarget==='seminar' && filterValue && filterValue!=="" && visibleItemsList.length){
                // if seminar filter is active and has a valid value insert a seminar card into the people list
                for(const el of hiddenSeminarList){
                    if(el.dataset.uid==filterValue){ // when the seminar card with the matching id is found

                        const clonedCard=el.cloneNode(true);

                        const len=visibleItemsList.length;
                        if(len<5){
                            const lastItem=visibleItemsList[len-1];
                            if(lastItem){
                                lastItem.insertAdjacentElement("afterend", clonedCard);
                                insertedSeminarCard=clonedCard;
                            }
                        }else{
                            const itemBeforeCardPosition=visibleItemsList[4];
                            if(itemBeforeCardPosition){
                                itemBeforeCardPosition.insertAdjacentElement("afterend", clonedCard);
                                insertedSeminarCard=clonedCard;
                            }
                        }

                    }
                }
            }
        })
    }


}

